export const GLAZE_ICE_DENSITY = 57; // lb/ft^3
export const RIME_ICE_DENSITY = 37; // lb/ft^3
